import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { SecuritiesPropertyService } from 'src/app/services/securities-property/securities-property.service';
import { MessageUtil } from 'src/app/utils/message.util';

@Component({
  selector: 'app-suspender-regras-convite-dialog',
  templateUrl: './suspender-regras-convite-dialog.component.html',
  styleUrls: ['./suspender-regras-convite-dialog.component.scss'],
})
export class SuspenderRegrasConviteDialogComponent implements OnInit {
  securitiesPropertyId: number | null = null;
  date: Date | null = null;
  note: string = '';

  constructor(
    private config: DynamicDialogConfig,
    public dialogRef: DynamicDialogRef,
    private securitiesPropertyService: SecuritiesPropertyService,
    private spinner: NgxSpinnerService,
    private messageUtil: MessageUtil
  ) {}

  ngOnInit(): void {
    this.securitiesPropertyId = this.config?.data?.securitiesPropertyId ?? null;
    this.date = new Date();
    this.note = '';
  }

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    if (this.securitiesPropertyId == null) {
      return;
    }
    if (!this.date) {
      this.messageUtil.generateMessage('warning', 'Atenção', 'Informe a data.');
      return;
    }
    const d = this.date;
    const dateStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      '0'
    )}-${String(d.getDate()).padStart(2, '0')}`;

    this.spinner.show();
    this.securitiesPropertyService
      .suspendInviteLimits({
        securitiesPropertyId: this.securitiesPropertyId,
        date: dateStr,
        note: (this.note || '').trim() || undefined,
      })
      .subscribe({
        next: () => {
          this.spinner.hide();
          this.messageUtil.generateMessage(
            'success',
            'Sucesso',
            'Regras de convite suspensas para o dia informado.'
          );
          this.dialogRef.close(true);
        },
        error: (error) => {
          this.spinner.hide();
          const ex = error?.error?.data?.exception;
          if (ex) {
            this.messageUtil.generateMessage(ex.type, ex.title, ex.message);
          } else {
            this.messageUtil.generateMessage(
              'error',
              'Erro',
              'Não foi possível suspender as regras.'
            );
          }
        },
      });
  }
}
